import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-change-hcp-history',
  templateUrl: './change-hcp-history.component.html',
  styleUrls: ['./change-hcp-history.component.scss'],
})
export class ChangeHcpHistoryComponent implements OnInit {

  @Input() handicapSystem: any;
  @Input() viewHcpSystem: any;
  @Input() headerTitle: string;

  constructor(private mdlCtrl : ModalController) {
   }

  ngOnInit() {
    console.log(this.handicapSystem,'Handicap System');
  }

  close(){
    this.mdlCtrl.dismiss()
  }

  changeHandicapSystem(data:any){
    this.mdlCtrl.dismiss(data)
  }

}
